import { render } from "./Stepper.vue?vue&type=template&id=734e5f90"
import script from "./Stepper.vue?vue&type=script&lang=ts"
export * from "./Stepper.vue?vue&type=script&lang=ts"
script.render = render

export default script